import { locales } from "@/i18n/config";
import { ChevronRight } from "@mui/icons-material";
import { Menu, MenuItem } from "@mui/material";
import { useLocale } from "next-intl";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";

const UserLanguageSwitchMenu = ({ parentOpen, onClose }) => {
  const currentLocale = useLocale();
  const pathname = usePathname();
  const router = useRouter();
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    if (!parentOpen) setAnchorEl(null);
  }, [parentOpen]);

  const openLanguageMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const closeLanguageMenu = () => {
    setAnchorEl(null);
  };

  const handleChangeLanguage = (locale) => {
    if (locale !== currentLocale) {
      const segments = pathname.split("/");
      segments[1] = locale;
      router.push(segments.join("/"));
    }
    closeLanguageMenu();
    onClose?.();
  };

  return (
    <>
      <MenuItem onClick={openLanguageMenu}>
        <div className="flex justify-between w-full items-center">
          <span>{currentLocale.toUpperCase()}</span>
          <ChevronRight fontSize="small" />
        </div>
      </MenuItem>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeLanguageMenu}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        MenuListProps={{
          dense: true,
          sx: {
            py: 0.25,
            "& .MuiMenuItem-root": {
              minHeight: 36,
              py: 0.75,
              px: 1,
              fontSize: "0.9rem",
            },
          },
        }}
      >
        {locales.map((locale) => (
          <MenuItem key={locale} onClick={() => handleChangeLanguage(locale)}>
            {locale.toUpperCase()}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default UserLanguageSwitchMenu;
